import getImageUrl from './getImageUrl'
import imageSizes from '../enums/imageSizes'

//	We get the closest resolution to the width, allowing for a divisor.

//	The divisor can be used to reduce the resolution, for example if the
//	image is approximately 1/2 the with of the page, set divisor to 2.
const getSmartResolution = (widthOverride, divisorOverride, mySizeType) => {
	const divisor = divisorOverride || 1
	const innerWidth = global.innerWidth * (typeof global.devicePixelRatio !== 'undefined' && !Number.isNaN(global.devicePixelRatio) ? global.devicePixelRatio : 1)
	const width = (typeof widthOverride !== 'undefined' && !Number.isNaN(parseInt(widthOverride, 10)) ?
		parseInt(widthOverride, 10) :
		innerWidth) / divisor
	let result
	let diff = 100000000000000

	const sizeType = mySizeType || 'items'

	Object.keys(imageSizes[sizeType]).forEach((idx) => {
		const imgType = imageSizes[sizeType][idx]
		const type = imgType.type
		const localDiff = Math.abs(width - (typeof imgType.x !== 'undefined' ? imgType.x : 0))

		if (localDiff < diff) {
			diff = localDiff
			result = type
		}
	})
	return result
}

//	Get the best SRC for the image
const getImageSrcByResolution = ({ content, resolution, width, sizeType, divisor = 1 }) => {
	let src = content

	if (Array.isArray(content)) {
		const bestResolution = resolution || getSmartResolution(width, divisor, sizeType)
		//	Start with the first image
		src = content[0]
		//	Grab the required resolution if available
		content.filter(obj => obj.type === bestResolution).every((obj) => {
			src = obj
			return false
		})
	}

	//	If we have an object in the src, assume we were passed a valid image object
	if (typeof src === 'object') {
		src = getImageUrl(src)
	}

	return src
}

export default getImageSrcByResolution



// WEBPACK FOOTER //
// ./src/utilities/getImageSrcByResolution.js